<header class="header-bar">
  <div class="d-flex">
    <div class="logo">
      <img alt="logo" src="assets/images/slogo.png" />
    </div>
    <div class="divider"></div>
    <div class="title">{{constants.HEADER_TITLE}}</div>
  </div>
  <div class="d-flex align-items-center">
    <div class="username" *ngIf="userInfo">
      {{ userInfo.firstname }} {{ userInfo.lastname }}
    </div>
    <i class="bi bi-person-circle icon fs-4" [matMenuTriggerFor]="menu"></i>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="logout()">
        <mat-icon>exit_to_app</mat-icon>
        <span>{{constants.LOGOUT}}</span>
      </button>
    </mat-menu>
  </div>
</header>
